import emit from '../../common/events';
import { DownloadType } from '../../common/utils/downloader/interfaces/downloader.interface';

export class ProductCatalogDownloadAnalytics {
  /**
   * Event to track when the download dropdown was toggled.
   *
   * @param identifier
   * @param element
   * @param dropdown
   */
  dropdownToggle(identifier: string, element: Element, dropdown: HTMLElement): void {
    emit({
      element: element,
      name: 'click',
      detail: {
        eventName: `${identifier}-option-dropdown`,
        action: dropdown.classList.contains('show') ? 'opening' : 'closing',
        label: 'Dropdown Button',
        comp: 'dropdown'
      }
    });
  }

  /**
   * Event to track when a download option is selected.
   *
   * @param identifier
   * @param element
   * @param option
   */
  optionSelection(identifier: string, element: Element, option: DownloadType): void {
    emit({
      element: element,
      name: 'click',
      detail: {
        eventName: `${identifier}-option-selection`,
        option: option,
        label: `Dropdown ${option}`,
        comp: 'dropdown',
      }
    });
  }
}
